import React from 'react';
import { Check } from 'lucide-react';
import { MysteryType } from '../../types';

interface DayButtonProps {
  day: number;
  mystery: MysteryType;
  isCompleted: boolean;
  onClick: (day: number) => void;
}

export const DayButton: React.FC<DayButtonProps> = ({
  day,
  mystery,
  isCompleted,
  onClick
}) => {
  const getMysteryStyles = () => {
    const base = 'flex-1 px-2 py-1 rounded text-xs font-medium border-2 transition-all duration-200 hover:scale-102';

    if (isCompleted) {
      // Completed state: lighter background with golden border
      switch(mystery) {
        case 'Joyful':
          return `${base} bg-amber-50 dark:bg-amber-950 border-sacred-gold text-amber-900 dark:text-amber-100`;
        case 'Sorrowful':
          return `${base} bg-purple-50 dark:bg-purple-950 border-sacred-gold text-purple-900 dark:text-purple-100`;
        case 'Glorious':
          return `${base} bg-blue-50 dark:bg-blue-950 border-sacred-gold text-blue-900 dark:text-blue-100`;
        default:
          return `${base} bg-gray-50 dark:bg-gray-950 border-sacred-gold text-gray-900 dark:text-gray-100`;
      }
    } else {
      // Uncompleted state: solid color background with matching border
      switch(mystery) {
        case 'Joyful':
          return `${base} bg-amber-100 dark:bg-amber-900 border-amber-400 dark:border-amber-600 text-amber-900 dark:text-amber-100`;
        case 'Sorrowful':
          return `${base} bg-purple-100 dark:bg-purple-900 border-purple-400 dark:border-purple-600 text-purple-900 dark:text-purple-100`;
        case 'Glorious':
          return `${base} bg-blue-100 dark:bg-blue-900 border-blue-400 dark:border-blue-600 text-blue-900 dark:text-blue-100`;
        default:
          return `${base} bg-gray-100 dark:bg-gray-900 border-gray-400 dark:border-gray-600 text-gray-900 dark:text-gray-100`;
      }
    }
  };

  return (
    <button
      onClick={() => onClick(day)}
      className={getMysteryStyles()}
      title={`Day ${day} - ${mystery} Mysteries${isCompleted ? ' (Completed)' : ''}`}
    >
      <div className="text-center">
        <div className="font-semibold">{day}</div>
        <div className="text-xs opacity-75">{mystery}</div>
        {isCompleted && <Check className="w-3 h-3 mx-auto mt-1" />}
      </div>
    </button>
  );
};